import { useProfile } from "@/hooks/useProfile";
import { useStayPlanContracts } from "@/hooks/useStayPlanContracts";
import { selectActiveWeeklyPlan } from "./petPlanDays";
import { planDatesAhead } from "@/lib/daycare-hotel/planFixedDays";
import { PlanDaysCard } from "./PlanDaysCard";

/** Dias fixos e próximas datas do plano semanal de creche do pet. */
export function PetPlanDaysSummary({ petId }: { petId: string | null }) {
  const { data: profile } = useProfile();
  const contracts = useStayPlanContracts("daycare", profile?.current_clinic_id ?? null, petId ? [petId] : []).data ?? [];
  const plan = selectActiveWeeklyPlan(contracts);
  if (!plan) return null;

  const today = new Date().toLocaleDateString("en-CA");
  const from = today > plan.startsOn ? today : plan.startsOn;
  const dates = planDatesAhead({
    anchor: plan.firstDueOn ?? plan.startsOn,
    from,
    weekdays: plan.fixedWeekdays,
    weekInterval: plan.weekInterval,
    startsOn: plan.startsOn,
  });
  return <PlanDaysCard name={plan.planName} weekdays={plan.fixedWeekdays} dates={dates} weekInterval={plan.weekInterval} />;
}
